import { isIdentityServiceEnabled } from "~/utils/identity-service";

const isIdentityService = isIdentityServiceEnabled();

/**
 * API path mappings. When identity-service is enabled, paths use the
 * Identity Service /api/v1/ conventions. Otherwise, paths use Zitadel's
 * management/auth API conventions.
 */
export const paths = {
  // Profile (profileService)
  getProfile: "/users/me/profile",
  updateProfile: "/users/me/profile",
  updatePassword: "/users/me/password",
  myMemberships: isIdentityService ? "/users/me/memberships" : "/memberships/me/_search",
  myMembershipsMethod: isIdentityService ? ("get" as const) : ("post" as const),

  // Admin - Users (adminServiceV1 / adminServiceV2)
  createUser: isIdentityService ? "/users" : "/users/human/_import",
  listUsers: "/users",
  listUsersMethod: isIdentityService ? ("get" as const) : ("post" as const),
  updateUser: (id: string) => (isIdentityService ? `/users/${id}` : `/users/${id}/profile`),
  deactivateUser: (id: string) => (isIdentityService ? `/users/${id}/deactivate` : `/users/${id}/_deactivate`),

  // Admin - Grants (adminServiceV1)
  searchGrants: isIdentityService ? "/users/grants" : "/users/grants/_search",
  searchGrantsMethod: isIdentityService ? ("get" as const) : ("post" as const),
  // Per-user grant list. When identity-service mode is enabled, this uses a dedicated route that
  // filters server-side; the Zitadel fallback still goes through the search
  // endpoint with a userId query.
  searchGrantsForUser: (userId: string) => (isIdentityService ? `/users/${userId}/grants` : "/users/grants/_search"),
  searchGrantsForUserMethod: isIdentityService ? ("get" as const) : ("post" as const),
  createGrant: (userId: string) => `/users/${userId}/grants`,
  deleteGrant: (userId: string, grantId: string) => `/users/${userId}/grants/${grantId}`,

  // Admin - Org Members (adminServiceV1)
  searchOrgMembers: isIdentityService ? "/orgs/current/members" : "/orgs/me/members/_search",
  searchOrgMembersMethod: isIdentityService ? ("get" as const) : ("post" as const),
  addOrgMember: isIdentityService ? "/orgs/current/members" : "/orgs/me/members",
  removeOrgMember: (userId: string) =>
    isIdentityService ? `/orgs/current/members/${userId}` : `/orgs/me/members/${userId}`,

  // Admin - Organizations (adminServiceV2)
  searchOrgs: isIdentityService ? "/organizations" : "/organizations/_search",
  searchOrgsMethod: isIdentityService ? ("get" as const) : ("post" as const),

  // Admin - Projects (adminServiceV1)
  searchGrantedProjects: isIdentityService ? "/projects/granted" : "/granted_projects/_search",
  searchGrantedProjectsMethod: isIdentityService ? ("get" as const) : ("post" as const),

  // Keys (adminServiceV1) — identity-service only. `id` may be the "me" sentinel on user routes.
  userKeys: (id: string) => `/users/${id}/keys`,
  userKey: (id: string, kid: string) => `/users/${id}/keys/${kid}`,
  agentKeys: (id: string) => `/agents/${id}/keys`,
  agentKey: (id: string, kid: string) => `/agents/${id}/keys/${kid}`,
};
